// extracted by mini-css-extract-plugin
export default {"Content":"Auth_Content__ahhVO","formAuth":"Auth_formAuth__q+Ewd"};